import debounce from 'lodash/debounce';
import React, { Component, Fragment, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import RenderTree, { NestedLoader } from './RenderTree';
import classNames from 'classnames';
import { SkeletonLoader } from '../util/SkeletonLoader';
import Search from '../../Search/Search'
import { getTestIdFormatter } from '../RenderFields/TaxonomyNodeHeader';


const SearchContainer = (props) => { 
  const { style, data, onInputChange, searchInput, searchPlaceHolder, totalCounts } = props
  const [hasSearch, setHasSearch] = useState(data.children.length );
  // console.log("🚀 ~ SearchContainer ~ props:", props, hasSearch, data.children.length)

  useEffect(() => {
    if (!hasSearch) {
      setHasSearch(data.children.length );
    }
  }, [data.children.length, totalCounts]);


  return hasSearch || searchInput ? (
    <div className="tableFilterModal__search" style={style}>
      <Search
        testId={`cs-${getTestIdFormatter(searchPlaceHolder)}`}
        placeholder={searchPlaceHolder}
        onChange={onInputChange}
        value={searchInput}
        width="auto"
        autoFocus={props.autoFocus}
        onClear={true}
        type="secondary"
        version="v2"
      />
    </div>
  ) : null;
};

class TreeView extends Component<any, any> {
  state = {
    data: {
      name: 'rootNode',
      uid: 'rootNode',
      toggled: true,
      children: [],
      loading: true
    },
    skip: 0,
    cursor: {},
    totalCounts: null,
    hasMore: true,
    searchInput: this.props.searchInput,
    loading: false,
    hasSearch: false
  };

  // Safe t function with empty string fallback
  t = (key: string) => {
    return this.props.t ? this.props.t(key) : ''
  }

  canFetch = typeof this.props.canFetch === 'boolean' ? this.props.canFetch : true;
  locationState = this.props.locationState && this.props.locationState.data;
  initialState = this.props.initialState && this.props.initialState.data;
  nestedLimit = this.props.nestedLimit ? this.props.nestedLimit : 30;
  limitForRoot = this.props.limitForRoot ? this.props.limitForRoot : 50;

  async componentDidMount() {
    try {

      document.addEventListener('assetFolderUpdated', this.fetchNewFolders, false)

      const { moduleName, setFolderTotalCounts } = this.props.userSelections
      if (!this.canFetch) {
        const stateData = this.props.initialState;
        this.setState({ data: stateData.data, totalCounts: stateData.totalCounts });
        return;
      }
      this.fetchInitRootData();
    } catch (error) {
      if (this.canFetch) {
        this.fetchInitRootData();
      }
      console.error(error);
    }
  }

  fetchNewFolders = () => {
    this.fetchInitRootData();
  }

  updateCbRefrence = (node) => {
    node.onToggle = () => {
      this.onToggle(node, false)
    }

    if (Array.isArray(node.children)) {
      node.children.forEach((child, index) => {
        if (child.id === 'loadmore') {
          const loadMoreNode = node.children[index]
          node.children.splice(index, 1, {
            ...loadMoreNode,
            onClick: () => this.handleLoadMoreClick(node),
          })
        }
        this.updateCbRefrence(child)
      })
    }
  }

  componentWillUnmount(): void {
    document.removeEventListener('assetFolderUpdated', this.fetchNewFolders, false)
    if (this.props.type === 'assetFolder') {
      const { history } = this.props.userSelections
      if (history && history?.location.pathname.includes('assets')) {
        // this.props.dispatch(setAssetFolderState(this.state))
      } else {
        // this.props.dispatch(setAssetFolderState({}))
      }
    }
  }

  // async componentDidUpdate(prevProps){
  //   try {
  //     if(this.canFetch) {
  //       if (
  //         !prevProps.isFilterDropdownOpen &&
  //         this.props.isFilterDropdownOpen &&
  //         typeof this.state.totalCounts !== 'number'
  //       ) {
  //         this.fetchInitRootData();
  //       }
  //     }
  //   } catch (error) {
  //     console.log("asynccomponentDidUpdate ~ error:", error)

  //   }
  // }

  iterateAndClearData = ({ node, action }) => {
    if (action === 'clearAll' && node.checked) {
      node.checked = false;
    }

    if (action === 'clearExceptBlank' && node.type !== 'blank' && node.checked) {
      node.checked = false;
    }

    if (Array.isArray(node.children)) {
      node.children.forEach((child) => {
        this.iterateAndClearData({ node: child, action });
      });
    }
  };

  clearSelection = ({ action = 'clearAll' }) => {
    const { data } = this.state;

    this.iterateAndClearData({ node: data, action });
    // const {onClearFilter} = this.props.userSelections
    // onClearFilter&& onClearFilter()
    this.props.userSelections.filterObject.value = [];
    this.setState({ data });
  };

  fetchInitRootData = async () => {
    try {
      this.setState({ loading: true });
      const { data, totalCounts } = await this.props.fetchMoreRootData({
        skip: 0,
        limit: this.limitForRoot,
        searchInput: this.state.searchInput
      });
      // console.log("fetchInitRootData ~ data", data)
      const children = data.map((object) => ({
        ...object,
        loading: true,
        children: [],
        root: true
      }));

      const treeObject = { name: 'rootNode', toggled: true, children };
      // this.updateDepthAndCheckedCount(treeObject.children);

      this.setState({
        data: treeObject,
        totalCounts,
        hasMore: true,
        cursor: {},
        loading: false
      });

      // const tableFilterModalTaxo = document.querySelector('#searchV2__filter__portal .tableFilterModal--taxonomy')
      // if(tableFilterModalTaxo && children.length >= 10) {
      //   tableFilterModalTaxo.style.bottom = '5px'
      // }

      // const tableFilterModalVarn = document.querySelector('#searchV2__filter__portal .tableFilterModal--variant')
      // if(tableFilterModalVarn && children.length >= 10) {
      //   tableFilterModalVarn.style.bottom = '5px'
      // }

    } catch (error) {
      this.setState({ loading: false });
      console.log('error', error.message);
    }
  };

  fetchMoreRootData = async () => {
    try {
      if (this.state.data.children.length >= this.state.totalCounts) {
        this.setState({ hasMore: false });
        return;
      }
      this.setState({ loading: true });
      const { skip, data } = this.state;
      const response = await this.props.fetchMoreRootData({
        skip: skip + this.limitForRoot,
        limit: this.limitForRoot,
        searchInput: this.state.searchInput
      });
      const children = response.data.map((object) => ({
        ...object,
        loading: true,
        children: [],
        root: true
      }));

      const treeObject = { ...data, children: [...data.children, ...children] };
      // this.updateDepthAndCheckedCount(treeObject.children);

      this.setState({
        skip: skip + this.limitForRoot,
        data: treeObject,
        totalCounts: response.totalCounts,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
      console.error(error);
    }
  };

  handleLoadMoreClick = async (node) => {
    try {
      const { data } = this.state;
      const prevChildren = node.children.filter((object) => object.id !== 'loadmore');
      let skip = node.skip + this.nestedLimit;

      const response = await this.props.fetchMoreNestedData({
        uid: node.uid,
        skip,
        limit: this.nestedLimit,
        node
      });

      let nextChildren = response.data.map((asset) => ({
        ...asset,
        loading: true,
        children: []
      }));

      const loadMoreObj = {
        name: this.t('TreeView.load_more') || 'Load More',
        id: 'loadmore',
        toggled: false,
        onClick: () => this.handleLoadMoreClick(node)
      };

      const treeObject = [...prevChildren, ...nextChildren];
      node.children = treeObject;
      if (response.totalCounts > skip + this.nestedLimit) {
        node.children.push(loadMoreObj);
      }
      node.skip = skip;
      // this.updateDepthAndCheckedCount(data.children);
      this.setState({ data: Object.assign({}, data) });
    } catch (error) {
      console.error(error);
    }
  };

  onToggle = (node, _toggled) => {
    if (node && node.id === 'loadmore') {
      return;
    }

    /*
     ** if node not active and not open -> first case: open it n mark as active
     ** else if node active then
     ** open it not open else close it
     */
    if (node.children) {
      if (node.toggled) {
        node.toggled = false;
      } else {
        node.toggled = true;
      }
    }

    const { cursor, data }: any = this.state;
    if (cursor) {
      cursor.active = false;
    }

    node.active = true;

    /*
     ** Fetch only when node.toggled is true
     ** In case of this.canFetch true
     ** if node.toggled true -> call ontoggle method after fetch
     ** of else block will call on toggle
     ** In case of this.canFetch false
     ** else block will only get called with toggle
     */
    if (this.canFetch && node.toggled) {
      this.setState({ cursor: node, data: Object.assign({}, data) }, async () => {
        try {
          const { cursor, data }: any = this.state;
          if (node.loading) {
            const response = await this.props.fetchMoreNestedData({
              uid: cursor.uid,
              skip: 0,
              limit: this.nestedLimit,
              node
            });

            let initSetChildren = response.data.map((object) => ({
              ...object,
              loading: true,
              children: []
            }));

            const loadMoreObj = {
              name: this.t('TreeView.load_more') || 'Load More',
              id: 'loadmore',
              toggled: false,
              onClick: () => this.handleLoadMoreClick(node)
            };

            cursor.children = [...initSetChildren];

            if (response.totalCounts > this.nestedLimit) {
              cursor.skip = 0;
              cursor.children.push(loadMoreObj);
            }

            cursor.loading = false;
            // this.updateDepthAndCheckedCount(data.children);
            this.setState({ cursor, data: Object.assign({}, data) });
          }
          if (this.props.onToggle) {
            this.props.onToggle({
              uid: node.uid,
              ...this.state
            });
          }
        } catch (error) {
          console.error(error);
        }
      });
    } else {
      this.setState({ cursor: node, data: Object.assign({}, data) });
      if (this.props.onToggle) {
        this.props.onToggle({
          uid: node.uid,
          ...this.state,
          cursor: node
        });
      }
    }
  };

  debounceSearch = debounce(async () => {
    try {
      this.setState({
        skip: 0,
        cursor: {},
        totalCounts: null,
        hasMore: true,
        data: {
          name: 'rootNode',
          uid: 'rootNode',
          toggled: true,
          children: [],
          loading: true
        }
      });
      await this.fetchInitRootData();
    } catch (error) {
      console.error(error);
    }
  }, 300);

  onInputChange = (value) => {
    try {
      const inputValue = value;
      this.setState({ searchInput: inputValue });
      this.debounceSearch();
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    // console.log("TreeView ~ render ~ this.props", this.state)

    const { Header, NestedEmptyState } = this.props.customDecorators || {};
    const noResultText = this.state.searchInput ? (this.t('TreeView.no_matching_results') || 'No matching results found!') : (this.t('TreeView.no_data_available') || 'No data available');
    const uniqId = `tableFilterScrollableDiv${this.props.type}`;
    const { children = [] } = this.state.data;

    let isBlankNodeSelected = children[0]?.type === 'blank' && children[0]?.checked;

    if (this.props.type == "taxonomy") {
      isBlankNodeSelected = children[0]?.type === 'blank' && this.props.userSelections.filterObject.value.find((fi) => fi.uid === '_blank');
    }

    if (this.props.type == "variant") {
      isBlankNodeSelected = children[0]?.type === 'blank' && this.props.userSelections.filterObject.uid.find((fi) => fi.uid === '$baseVariant');
    }

    const style: any = isBlankNodeSelected ? { pointerEvents: 'none', opacity: 0.3, cursor: 'notAllowed' } : {};

    const userSelections = this.props.userSelections || {};
    /**
     * This enables infinite scrolling at root level, fetch data str async and
     * update its root and children, further add loadmore button for nested children
     **/
    if (this.canFetch) {
      return (
        <>
          <SearchContainer
            style={style}
            data={this.state.data}
            onInputChange={this.onInputChange}
            // props={this.props}
            searchInput={this.state.searchInput}
            searchPlaceHolder={this.props.searchPlaceHolder}
            totalCounts={this.state.totalCounts}
          />
          <ul className="tableFilterModal__suggestion-items" id={uniqId} >
            <InfiniteScroll
              dataLength={this.state.data.children.length}
              next={this.fetchMoreRootData}
              hasMore={this.state.hasMore}
              loader={<SkeletonLoader size={5} />}
              scrollableTarget={uniqId}
              hasChildren={true}>
              {!this.state.loading && this.state.totalCounts === 0 ? (
                <li className="tableFilterModal__no-result" data-test-id="cs-filters-result-empty">
                  {noResultText}
                </li>
              ) : (
                <RenderTree
                  data={this.state.data}
                  onToggle={this.onToggle}
                  decorators={{ Header, NestedLoader, NestedEmptyState }}
                  userSelections={{ ...userSelections, headerStyle: style, clearSelection: this.clearSelection }}
                  depth={-1}
                  canFetch={this.canFetch}
                  searchInput={this.state.searchInput}
                  handleSelectQuery={this.props.handleSelectQuery}
                />
              )}
            </InfiniteScroll>
          </ul>
        </>
      );
    }

    return (
      <Fragment>
        {this.props.contentTypeLabel.hasSearch ? (
          <div className="tableFilterModal__search" style={style}>
            <Search
              testId={`cs-${getTestIdFormatter(this.props.searchPlaceHolder)}`}
              placeholder={this.props.searchPlaceHolder}
              onChange={this.props.contentTypeLabel.onInputChange}
              value={this.props.contentTypeLabel.searchTerm}
              width="auto"
              autoFocus={this.props.autoFocus}
              onClear={true}
              type="secondary"
              version="v2"
            />
          </div>
        ) : null}
        <ul
          className={classNames('tableFilterModal__suggestion-items', userSelections.moduleName === 'entries-lhs-ctview' && 'views-container--items')}
          id={uniqId}
        >
          <RenderTree
            data={this.state.data}
            onToggle={this.onToggle}
            decorators={{ Header, NestedLoader, NestedEmptyState }}
            userSelections={{ ...userSelections, clearSelection: this.clearSelection }}
            depth={-1}
            canFetch={this.canFetch}
            searchInput={this.props.contentTypeLabel.searchTerm}
            handleSelectQuery={this.props.handleSelectQuery}
          />
        </ul>
      </Fragment>
    );
  }
}


export default TreeView;

//todo name it properly
// handleAdditionalNodeClick = () => {
//   const { data } = this.state;
//   let allSelectedData = [];
//   // this.updateDepthAndCheckedCount(data.children, 0, allSelectedData);

//   this.setState({ data });
// };

// updateDepthAndCheckedCount = (data, depth = 0, allSelectedData = []) => {
// data.forEach((item) => {
//   item.depth = depth;

//   item.handleAdditionalNodeClick = this.handleAdditionalNodeClick;
//   item.onToggle = () => {
//     this.onToggle(item, false);
//   };
//   if (item.checked) {
//     allSelectedData.push(item);
//   }
//   let checkedCount = item.checked === true ? 1 : 0;

//   if (item.children && item.children.length > 0) {
//     const childData = this.updateDepthAndCheckedCount(item.children, depth + 1, allSelectedData);
//     item.children = childData;
//     checkedCount += childData.reduce((acc, child) => acc + child.checkedCount, 0);
//   }

//   item.checkedCount = checkedCount;
// });

// return data;
// };

// updateOnToggleRef = (node: any = {}) => {
//   node.onToggle = () => {
//     this.onToggle(node, false);
//   };
//   if (Array.isArray(node.children)) {
//     node.children.forEach((child) => {
//       this.updateOnToggleRef(child);
//     });
//   }
// };
